module.exports = __webpack_public_path__ + "static/media/warning-small.802c9f21.svg";